
import { sliderCourse, sliderSleepAids, sliderLogbook } from 'img/SleepPage';

export type AudioSampleVariant = 'course' | 'sleepAids' | 'logbook';

type AudioSampleConfig = {
  image: string;
  headline: string;
  description: string;
  listItems: string[];
  buttonTitle: string;
};

export const AudioSampleItemsConfig: Record<AudioSampleVariant, AudioSampleConfig> = {
  course: {
    image: sliderCourse,
    headline: 'Tschüss Schlafprobleme',
    description: 'Verstehe deinen Schlaf – und lerne, ihn aktiv zu verbessern.',
    listItems: [
      '9 Kurskapitel: Grundlagen, Tipps, Tricks und Sonderfälle',
      'Praktische Trainings zu jedem Kapitel',
      'Konzipiert und erstellt von Schlafforscher Dr. Albrecht Vorster',
    ],
    buttonTitle: 'Höre kostenfrei ein Kapitel aus der App an',
  },
  sleepAids: {
    image: sliderSleepAids,
    headline: 'Einfacher einschlafen',
    description: 'Alles, was du für einen leichteren Weg in den Schlaf brauchst.',
    listItems: [
      'Umfangreiche Bibliothek mit über 100 Schlafhilfen',
      'Wissenschaftlich fundiert – konzipiert und erstellt von Expert:innen',
      'Geschichten, Musik, Hypnosen – eine neue Welt für jede Nacht',
    ],
    buttonTitle: 'Höre kostenfrei eine Schlafhilfe aus der App an',
  },
  logbook: {
    image: sliderLogbook,
    headline: 'Deinen Schlaf verstehen',
    description: 'Dein persönliches Schlaflogbuch mit übersichtlichen Schlafstatistiken hilft dir dabei.',
    listItems: [
      'Halte fest, wie du geschlafen hast und wie du dich heute fühlst.',
      'Erkenne Muster in deinen Nächten, deinem Rhythmus und deiner Energie.',
      'Wirksamkeit in wissenschaftlicher Studie belegt',
    ],
    buttonTitle: 'Höre kostenfrei eine Hörprobe aus der App an',
  },
};